import { Box, Typography, Container, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import BrandMark from "@/components/BrandMark";
import { APP_SHORT_NAME } from "@/constants/branding";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        borderTop: 1,
        borderColor: "divider",
        pt: 6,
        pb: 4,
        mt: "auto",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} sx={{ mb: 4 }}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Box
              component={RouterLink}
              to="/"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 2,
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <BrandMark size={32} fontSize={12} borderRadius={1.5} />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                }}
              >
                {APP_SHORT_NAME}
              </Typography>
            </Box>
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                maxWidth: 300,
              }}
            >
              {t("app.subtitle")}
            </Typography>
          </Grid>
          <Grid size={{ xs: 6, md: 2 }}>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 600,
                mb: 1.5,
              }}
            >
              {t("footer.platform")}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Link
                href="/"
                underline="hover"
                variant="body2"
                sx={{
                  color: "text.secondary",
                }}
              >
                {t("nav.home")}
              </Link>
              <Link
                href="/companies"
                underline="hover"
                variant="body2"
                sx={{
                  color: "text.secondary",
                }}
              >
                {t("nav.companies")}
              </Link>
            </Box>
          </Grid>
          <Grid size={{ xs: 6, md: 2 }}>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 600,
                mb: 1.5,
              }}
            >
              {t("footer.account")}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Link
                href="/login"
                underline="hover"
                variant="body2"
                sx={{
                  color: "text.secondary",
                }}
              >
                {t("auth.signIn")}
              </Link>
              <Link
                href="/reviews"
                underline="hover"
                variant="body2"
                sx={{
                  color: "text.secondary",
                }}
              >
                {t("nav.reviews")}
              </Link>
            </Box>
          </Grid>
        </Grid>
        <Box
          sx={{
            borderTop: 1,
            borderColor: "divider",
            pt: 3,
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Link
            href="https://pinehood.tech"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            variant="caption"
            sx={{
              color: "text.secondary",
            }}
          >
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </Link>
          <Box
            sx={{
              display: "flex",
              gap: 2,
            }}
          >
            <Link
              href="https://cloud.pinehood.tech/terms/"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              variant="caption"
              sx={{
                color: "text.secondary",
              }}
            >
              {t("footer.terms")}
            </Link>
            <Link
              href="https://cloud.pinehood.tech/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              variant="caption"
              sx={{
                color: "text.secondary",
              }}
            >
              {t("footer.privacy")}
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
